import { defineComponent as _defineComponent } from 'vue'
import { vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["placeholder", "readonly"]

import { computed, withDefaults } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'MInput',
  props: {
    value: {},
    placeholder: {},
    readonly: { type: Boolean },
    disabled: { type: Boolean },
    warning: { type: Boolean },
    danger: { type: Boolean },
    lazy: { type: Boolean }
  },
  emits: ["input", "change", "focus", "blur", "keydown", "click"],
  setup(__props: any, { emit: emits }) {

const props = __props;




const localData = computed({
  get: () => props.value,
  set: (nv) => emits("input", nv)
});

return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createElementBlock("input", {
    class: _normalizeClass(["m-input", { warning: _ctx.warning, danger: _ctx.danger, 'read-only': _ctx.readonly, disabled: _ctx.disabled }]),
    type: "text",
    placeholder: _ctx.placeholder,
    readonly: _ctx.readonly,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((localData).value = $event)),
    onChange: _cache[1] || (_cache[1] = ($event: any) => (emits('focus', $event))),
    onFocus: _cache[2] || (_cache[2] = ($event: any) => (emits('focus', $event))),
    onBlur: _cache[3] || (_cache[3] = ($event: any) => (emits('blur', $event))),
    onKeydown: _cache[4] || (_cache[4] = ($event: any) => (emits('keydown', $event))),
    onClick: _cache[5] || (_cache[5] = ($event: any) => (emits('click', $event)))
  }, null, 42, _hoisted_1)), [
    [_vModelText, localData.value]
  ])
}
}

})